<template>
    <default-modal
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
        @close="closeModal"
    >
        <ns-loader
            v-if="feed !== null"
            ref="nsLoader"
            :to-load="toLoad"
            :fetch-timer="null"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <el-form
                slot="content"
                ref="form"
                :model="form"
                :rules="rules"
                class="modal-confirm-feed"
            >
                <template>
                    <div class="gcmcn-inputs-container">
                        <div class="flex-basis-10">
                            <el-form-item class="gcmcn-form-input" prop="booking_key">
                                <div class="gcmcn-form-label" style="margin-bottom: 15px;">Work Order</div>
                                <el-input
                                    size="mini"
                                    v-model="form.booking_key"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </template>
            </el-form>
        </ns-loader>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="confirmFeed"
            >Validate</el-button>
        </div>
    </default-modal>

</template>

<script>
import moment from 'moment';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
export default {

    components: {
        DefaultModal,
        NsLoader,
        LoadingTemplate,
    },

    props: {

    },

    data (){
        return {
            showModal: false,
            form: {
                booking_key: '',
            },
            loading: false,
            feed: null,
            event: null,
            videoSource: null,
        };
    },

    computed: {
        toLoad () {
            return [
                {
                    name: 'feeds',
                    model: 'feeds',
                    uid: this.feed.uid,
                }
            ];
        },
        feedIsInternalSource (){
            return this.feed.source_type === 'internal';
        },
        rules (){
            let rules = {
                booking_key: [{validator: this.workOrderRule}],
            };
            return rules;
        },
    },

    mounted (){
    },

    methods: {

        workOrderRule (rule, value, callback) {
            if(this.form.booking_key.length > 15) {
                return callback(new Error('The work order must be less than 15 characters'))
            }
            callback();
        },
        onDataFetched (res){
            this.form.booking_key = this.feed.booking_key;
        },
        open (feed, event){
            this.$set(this, 'feed', feed);
            this.$set(this, 'event', event);
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
            this.$set(this, 'feed', null);
            this.$set(this, 'event', null);
        },
        confirmFeed (){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;
                this.loading = true;

                let bookingKeyResponse = await this.$store.dispatch('patchItem', {
                        item: {
                            uid: this.feed.uid,
                            url: this.feed.url,
                            booking_key: this.form.booking_key,
                        },
                        model: 'feeds',
                    })
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Work Order of ${this.feed.display_name} updated`
                    });
                    this.$emit('on-trigger-refresh');
                    this.closeModal();
                }).catch((e) => {
                    console.error(e);
                    this.$notify({
                        type: 'error',
                        title: `Error on update work order of feed ${this.feed.display_name}`
                    });
                }).finally(() => {
                    this.loading = false;
                });

            })
        },

    },
};
</script>

<style lang="scss">
.modal-confirm-feed{
    .el-input:not(.hours):not(.minutes):not(.seconds):not(.digital-clock){
        width: 100%;
    }
    .el-alert{
        .el-form-item__error{
            color: #ff1100;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/feed-update-work-order.vue